module.exports = __webpack_public_path__ + "assets/Kidnapping.80687572.svg";